import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@app/admin-station/work-center/user/services/user.service';
import { IFeedback } from '@app/main/interfaces/feedback';
import { FileTypeEnum } from '@app/shared/components/file-upload/constants';
import { SnackBarService } from '@app/shared/components/snackbar/snackbar.service';
import { SnackBarsTypes } from '@app/shared/enums/snackbars';
import { FileUploadService } from '@app/shared/services/utils/file-upload.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'cm-header-feedback',
  templateUrl: './header-feedback.component.html',
  styleUrls: ['./header-feedback.component.scss'],
})
export class HeaderFeedbackComponent {
  public categories: any[];
  public feedbackForm: FormGroup;
  public isLoading: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<HeaderFeedbackComponent>,
    private userService: UserService,
    public fileUploadService: FileUploadService,
    private snackBarService: SnackBarService
  ) {
    this.categories = [
      'Application stability',
      'Key actions are difficult to perform',
      'Application performance',
      'Enhancement suggestion',
      'Bug',
    ];

    this.feedbackForm = this.formBuilder.group({
      category: [null, Validators.required],
      feedback: [null, Validators.required],
      files: [null],
    });
  }

  public displayExpr(category: string): string {
    return category || '';
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public submitForm(): void {
    this.isLoading = true;
    const feedback: IFeedback = this.feedbackForm.value;
    const indexQty = (feedback.files || []).map((i) => i.index);
    feedback.files = (feedback.files || []).map((i) => i.url);

    this.userService
      .submitFeedback(feedback)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(() => {
        this.snackBarService.openSnackBar({
          type: SnackBarsTypes.SUCCESS,
          description: 'header.feedback-submitted',
        });

        indexQty.forEach((v) => this.fileUploadService.removeFile(v));
        this.feedbackForm.reset();
        this.closeDialog();
      });
  }

  public setFile(file: any): void {
    const files = [...(this.feedbackForm.value.files || []), file];
    this.feedbackForm.patchValue({ files });
  }

  public removeFile(): void {
    const files = this.fileUploadService.getFiles(null, FileTypeEnum.IMAGES);
    this.feedbackForm.patchValue({ files: files?.length ? files : null });
  }
}
